module.exports = __webpack_public_path__ + "img/ai_ugc_entrance.f4c9000.png";